'use strict';

module.exports = /* @ngInject */ function ($scope, $attrs, $filter, feInventoryArticleService, basketService, feProductService, $q) {

    // this controller gets called in frontend basket view but also in supplier backend lieferavis. we should either separate these two
    // things from each other or keep it in mind that changes might affect more than just one thing.

    // attribute variables
    $scope.supplier_company_id = '';
    $scope.sku = '';
    $scope.quantity = null;
    $scope.basketItemIndex = '';

    $scope.showModifiedAlert = false;
    $scope.dateModelFormat = 'yyyy-MM-dd';
    const DATE_FORMAT = 'dd.MM.yyyy';


    $scope.minimumDeliveryDate = null;
    $scope.deliveryDate = null;
    $scope.expectedDeliveryDate = null;
    $scope.deliveryTime = null;

    let desiredDeliveryDate = null;

    $scope.article = null;
    $scope.inventory = {};
    $scope.showInventories = false;

    $scope.moment = window.moment;

    $scope.getInventory = getInventory;

    let inventoryHasQuantity = false;

    $scope.gettxt = gettxt; // gettxt variable for javascript

    /**
     * Inventory daten verarbeiten
     * @param  {json} data
     */
    const getInventorySuccess = function (data) {
        // set inventories
        $scope.inventory.items = data;
        $scope.inventory.quantitySum = feInventoryArticleService.getInventorySum($scope.inventory.items);
        $scope.inventory.availabilityClass = feInventoryArticleService
            .getAvailabilityClass($scope.quantity, $scope.inventory.quantitySum);

        if ($scope.inventory.items.length === 1
            && $scope.quantity > $scope.inventory.items[0].quantity) {
            $scope.quantity = $scope.inventory.items[0].quantity;
            $scope.showModifiedAlert = true;
        }
    };

    /**
     * alle Inventories ziehen
     */
    function getInventory() {
        $scope.inventory = {};
        $scope.inventories = [];
        return feInventoryArticleService.inventory.query(
            {
                supplier_company_id: $scope.supplier_company_id,
                sku: $scope.sku
            })
            .$promise.then(
                //success
                function (data) {
                    getInventorySuccess(data);
                }
            );
    }

    /**
     * Check if the supplier has articles in stock.
     */
    function hasArticleQuantities() {
        if ($scope.sku) {
            return feInventoryArticleService.hasArticleQuantity.query(
                {
                    supplier_company_id: $scope.supplier_company_id,
                    sku: $scope.sku
                })
                .$promise.then(
                    //success
                    function (data) {
                        inventoryHasQuantity = data;
                    }
                );
        } else {
            inventoryHasQuantity = false;
            return Promise.resolve();
        }
    }

    /**
     * Get the quantity of articles in stock.
     */
    function getArticleQuantity() {
        if ($scope.sku) {
            return feInventoryArticleService.getArticleQuantity.query(
                {
                    supplier_company_id: $scope.supplier_company_id,
                    sku: $scope.sku
                })
                .$promise.then(
                    //success
                    function (data) {
                        $scope.inventory.quantitySum = data.quantity;
                        $scope.inventory.availabilityClass = feInventoryArticleService.getAvailabilityClass($scope.quantity,
                            $scope.inventory.quantitySum);
                    }
                );
        } else {
            $scope.inventory.quantitySum = 0;
            return Promise.resolve();
        }
    }

    /**
     * Initialize neccessary data.
     *
     * @param {*} supplierGroupId - supplier group id
     * @param {*} articleNumber   - article number (sku)
     * @param {*} quantity          - quantity
     * @param {*} basketItemIndex - basket item index
     */
    $scope.init = function (supplierGroupId, articleNumber, quantity, basketItemIndex) {
        $scope.supplier_company_id = supplierGroupId;
        $scope.sku = articleNumber;
        $scope.quantity = quantity;
        $scope.basketItemIndex = basketItemIndex;
        // delivery date calculation should only be done if the basket item is an article
        if ($scope.basketItemIndex && $scope.basketItemIndex !== '') {
            $q.all([hasArticleQuantities(), getArticleQuantity()])
                .then(function () {
                    // only calculate the date if we're in the basket
                    initDateFromBasketItem();
                });
        } else {
            getInventory();
        }
    };

    // Flag zum anzeigen der Inventories
    $scope.showInventory = function () {
        $scope.showInventories = !$scope.showInventories;
    };

    /**
     * Add business days to a given date.
     *
     * @param {*} d - Date to add the business day to
     * @param {*} n - number of business days to add
     */
    function addBusinessDays(d, n) {
        d = new Date(d.getTime());
        const day = d.getDay();
        d.setDate(d.getDate() + n + (day === 6 ? 2 : +!day) + (Math.floor((n - 1 + (day % 6 || 1)) / 5) * 2));
        return d;
    }

    /**
     * Init delivery date from the basket item if present. Otherwise delivery date gets initialized by the inventory item.
     */
    function initDateFromBasketItem() {
        basketService.getUniteArticleByIndex.query(
            {
                basket_item_id: $scope.basketItemIndex
            })
            .$promise.then(function (data) {
            $scope.deliveryTime = data.deliveryTime;
            desiredDeliveryDate = data.desiredDeliveryDate;
            if (inventoryHasQuantity) { // if inventory has article
                $scope.minimumDeliveryDate = addBusinessDays(new Date(), data.deliveryTime);
            }

            const minimumDate = addBusinessDays(new Date(), data.deliveryTime);
            $scope.minimumDeliveryDate = minimumDate;

            if (data.deliveryTime === 0) {
                $scope.expectedDeliveryDate = $scope.gettxt.basket.deliveryDateUnknown;
            } else {
                $scope.expectedDeliveryDate = inventoryHasQuantity ?
                    $filter('date')(addBusinessDays(new Date(), data.deliveryTime), DATE_FORMAT) :
                    $filter('date')(minimumDate, DATE_FORMAT);
            }

            const isBeforeMinimumDate = moment(data.desiredDeliveryDate, DATE_FORMAT)
                .isSameOrBefore(moment($scope.minimumDeliveryDate, DATE_FORMAT))
            $scope.deliveryDate = data.desiredDeliveryDate && !isBeforeMinimumDate ?
                new Date(data.desiredDeliveryDate) : null;
        });
    }

    /**
     * Update the basket item with the desired delivery date.
     */
    $scope.updateDesiredDeliveryDate = function (deliveryDate) {
        // this looks dumb but the date needs to have double quotes around and .toString() doesn't do this
        // It's mandatory for Spring to be able to parse the given date to LocalDate
        desiredDeliveryDate = "\"" + $filter('date')(deliveryDate, $scope.dateModelFormat) + "\"";
        if (deliveryDate === "" || deliveryDate === null) {
            desiredDeliveryDate = null;
        }
        basketService.getUniteArticleByIndex.update(
            {basket_item_id: $scope.basketItemIndex}, desiredDeliveryDate
        ).$promise.then(function (data) {
        });
    };


    /**
     * Disable weekends for datepicker.
     *
     * @param {Date} date
     * @returns {boolean}
     */
    $scope.disableWeekendsForDatepicker = function (date) {
        const day = date.getDay();
        return day === 1 || day === 2 || day === 3 || day === 4 || day === 5;
    };


};
